import { render, staticRenderFns } from "./serviceSelect.vue?vue&type=template&id=25778b2e&scoped=true"
import script from "./serviceSelect.vue?vue&type=script&lang=js"
export * from "./serviceSelect.vue?vue&type=script&lang=js"
import style0 from "./serviceSelect.vue?vue&type=style&index=0&id=25778b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25778b2e",
  null
  
)

export default component.exports